export default "__VITE_ASSET__BWoPUzXJ__"